import { PopupActions, PopupContent } from '@/components/PagePopup/PopupContent';
import { Button } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
import { FailedPaymentPopup as PopupData } from '@/constants/popups';
import type { PagePopupProps, PopUpPosition, PopUpVariant } from '@/components/PagePopup/PagePopup';
import { ExclamationMarkInTriangle } from '@/components/AccountPage/Partnerships/ExclamationMarkInTriangle';
import { UpdatePaymentButton } from '@/components/UpdatePaymentButton';
export const getFailedPaymentPopupProps = ({
  onClick,
  revalidateKey
}: {
  onClick?: () => void;
  revalidateKey?: string;
}): PagePopupProps | null => {
  const popupId = 'failed-payment-popup';
  const icon = <div className="mb-1.5 flex h-11 w-11 items-center justify-center rounded-full bg-red-100 dark:bg-[#4A2E38]">
      <ExclamationMarkInTriangle className="text-red" />
    </div>;
  return {
    storageKey: popupId,
    variant: 'default' as PopUpVariant,
    position: 'bottom-right' as PopUpPosition,
    duration: undefined,
    excludeSlugs: ['/pricing'],
    delay: 750,
    revalidateKey,
    children: <PopupContent icon={icon} mainTitle={PopupData.mainTitle} subtitle={PopupData.subtitle} variant="default">
        <Text className="font-sans text-sm dark:text-gray-200">
          {PopupData.description}
        </Text>
        <PopupActions>
          <Button asChild className="w-full font-semibold" fontSize="sm" onClick={() => {
          window.postMessage({
            type: 'DISMISS_POPUP'
          }, '*');
          onClick?.();
        }} size="lg" variant="error">
            <UpdatePaymentButton>{PopupData.cta}</UpdatePaymentButton>
          </Button>
        </PopupActions>
      </PopupContent>,
    onClickDismiss: () => {
      onClick?.();
    },
    noXIcon: {
      desktop: false,
      mobile: false
    },
    mobileChildren: <PopupContent mainTitle="Your last payment didn't go through" variant="mobile-payment-issue">
        <div className="flex w-full flex-col items-center justify-center gap-3">
          <div className="text-center dark:text-gray-200">
            Your subscription is currently on hold. <br />
            To regain full access, update your payment details.
          </div>
          <Button asChild className="w-full font-heading font-semibold" fontSize="sm" onClick={() => {
          window.postMessage({
            type: 'DISMISS_POPUP'
          }, '*');
          onClick?.();
        }} size="lg" variant="error">
            <UpdatePaymentButton>{PopupData.cta}</UpdatePaymentButton>
          </Button>
          <Button
        // NOTE: Added -mb-4 to minimise the gap between the transparent button and the edge of the popup given that the popup container adds equal padding everywhere and is used by other popups
        className="-mb-4 w-min font-heading font-semibold" fontSize="sm" onClick={() => {
          window.postMessage({
            type: 'DISMISS_POPUP'
          }, '*');
          onClick?.();
        }} size="lg" variant="transparent">
            Dismiss
          </Button>
        </div>
      </PopupContent>
  };
};